import { render, staticRenderFns } from "./BowFormPropose.vue?vue&type=template&id=658fd6f2&"
import script from "./BowFormPropose.vue?vue&type=script&lang=js&"
export * from "./BowFormPropose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowInput: require('/workspace/components/atoms/BowInput/BowInput.vue').default,BowButton: require('/workspace/components/atoms/BowButton/BowButton.vue').default,BowSkeleton: require('/workspace/components/atoms/BowSkeleton/BowSkeleton.vue').default})
